<template>
    <div class="thread-timeline">
        <div
            v-for="(entry, index) in entries"
            :key="entry.id"
            class="timeline-entry"
            :class="`entry-${entry.type}`"
        >
            <ThreadTimelineEntry
                :entry="entry"
                :index="index"
                :entries="entries"
                :files="filesByEntryId?.[entry.id] ?? []"
                :thread-open="threadOpen"
                :responding-proposal-id="respondingProposalId"
                @confirm="(id) => emit('confirm', id)"
                @cancel="(id) => emit('cancel', id)"
                @open="(id, name) => emit('open', id, name)"
                @download="(id, name) => emit('download', id, name)"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import ThreadTimelineEntry from "@/components/Thread/ThreadTimelineEntry.vue";
import type { ThreadEntrySchema } from "@/stores/threads-store";

// A file attachment, projected from its FILE context item and shown inside the
// bubble of the message it was sent with.
export interface TimelineFile {
    fileId: string;
    filename: string;
    size?: string;
}

defineProps<{
    entries: ThreadEntrySchema[];
    // Committed files grouped by the id of the message they were sent with.
    filesByEntryId?: Record<string, TimelineFile[]>;
    threadOpen?: boolean;
    // The proposal the user just answered; its approval buttons hide immediately.
    respondingProposalId?: string | null;
}>();

const emit = defineEmits<{
    confirm: [entryId: string];
    cancel: [entryId: string];
    open: [fileId: string, filename: string];
    download: [fileId: string, filename: string];
}>();
</script>

<style scoped>
.thread-timeline {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
}
</style>
